import React from 'react'

import type { IconProps } from './types'

const GraphicBag: React.FC<IconProps> = ({ size = 40, ...rest }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" {...rest}>
      <path
        d="M62.2147 26.1043V46.7685C62.2147 51.7625 58.7432 55.9322 54.0693 56.9988C53.3129 57.1928 52.5177 57.28 51.7032 57.28H12.2947C12.2074 57.28 12.1202 57.2801 12.0329 57.2704C6.34078 57.1346 1.7832 52.4897 1.7832 46.7685V26.1043C1.7832 20.3831 6.34078 15.7382 12.0329 15.6122C12.1202 15.5928 12.2074 15.5928 12.2947 15.5928H51.7032C52.5177 15.5928 53.3129 15.68 54.0693 15.874C58.7335 16.9407 62.2147 21.1103 62.2147 26.1043Z"
        fill="#0092F2"
      />
      <path
        d="M62.2147 26.1043V46.7685C62.2147 51.7625 58.7432 55.9322 54.0693 56.9988C53.3129 57.1928 52.5177 57.28 51.7032 57.28H12.2947C12.2074 57.28 12.1202 57.2801 12.0329 57.2704C6.34078 57.1346 1.7832 52.4897 1.7832 46.7685V26.1043C1.7832 20.3831 6.34078 15.7382 12.0329 15.6122C12.1202 15.5928 12.2074 15.5928 12.2947 15.5928H51.7032C52.5177 15.5928 53.3129 15.68 54.0693 15.874C58.7335 16.9407 62.2147 21.1103 62.2147 26.1043Z"
        fill="#00BEBF"
      />
      <path
        d="M62.2147 26.1043V46.7685C62.2147 51.7625 58.7432 55.9322 54.0693 56.9988C53.3129 57.1928 52.5177 57.28 51.7032 57.28H12.2947C12.2074 57.28 12.1202 57.2801 12.0329 57.2704C6.34078 57.1346 1.7832 52.4897 1.7832 46.7685V26.1043C1.7832 20.3831 6.34078 15.7382 12.0329 15.6122C12.1202 15.5928 12.2074 15.5928 12.2947 15.5928H51.7032C52.5177 15.5928 53.3129 15.68 54.0693 15.874C58.7335 16.9407 62.2147 21.1103 62.2147 26.1043Z"
        fill="url(#paint0_radial_3474_63686)"
      />
      <path
        d="M62.2147 26.1043V46.7685C62.2147 51.7625 58.7432 55.9322 54.0693 56.9988C53.3129 57.1928 52.5177 57.28 51.7032 57.28H12.2947C12.2074 57.28 12.1202 57.2801 12.0329 57.2704C6.34078 57.1346 1.7832 52.4897 1.7832 46.7685V26.1043C1.7832 20.3831 6.34078 15.7382 12.0329 15.6122C12.1202 15.5928 12.2074 15.5928 12.2947 15.5928H51.7032C52.5177 15.5928 53.3129 15.68 54.0693 15.874C58.7335 16.9407 62.2147 21.1103 62.2147 26.1043Z"
        fill="url(#paint1_radial_3474_63686)"
      />
      <path
        d="M18.5981 15.6025V57.2897H12.295C12.2077 57.2897 12.1205 57.2897 12.0332 57.28V15.6122C12.1205 15.5928 12.2077 15.5928 12.295 15.5928H18.5981V15.6025Z"
        fill="#FB6E7E"
      />
      <path
        d="M18.5981 15.6025V57.2897H12.295C12.2077 57.2897 12.1205 57.2897 12.0332 57.28V15.6122C12.1205 15.5928 12.2077 15.5928 12.295 15.5928H18.5981V15.6025Z"
        fill="url(#paint2_radial_3474_63686)"
      />
      <path
        d="M54.0707 15.8741V56.9989C53.3143 57.1928 52.5192 57.2801 51.7046 57.2801H47.5059V15.6025H51.7046C52.5192 15.6025 53.3046 15.6898 54.0707 15.8741Z"
        fill="#FB6E7E"
      />
      <path
        d="M54.0707 15.8741V56.9989C53.3143 57.1928 52.5192 57.2801 51.7046 57.2801H47.5059V15.6025H51.7046C52.5192 15.6025 53.3046 15.6898 54.0707 15.8741Z"
        fill="url(#paint3_radial_3474_63686)"
        fill-opacity="0.2"
      />
      <path
        d="M40.6885 33.3773L38.8752 30.7979L34.8898 33.6003V28.7324H31.7382V33.3967L28.0728 30.5167L26.1237 32.9991L30.6716 36.5676L25.9395 39.8936L27.7528 42.473L31.7382 39.6706V44.5385H34.8898V39.8742L38.5552 42.7542L40.5043 40.2718L35.9564 36.7033L40.6885 33.3773Z"
        fill="url(#paint4_linear_3474_63686)"
      />
      <path
        d="M29.547 9.639H37.45C40.0003 9.639 42.0754 12.1311 42.0754 15.1954L45.1591 15.5348V14.2742C45.1591 10.1045 42.347 6.72021 38.8754 6.72021C38.8754 6.72021 28.1409 6.72021 28.1312 6.72021C26.153 6.72021 24.3009 7.69961 23.1567 9.30931C22.1773 10.696 20.5094 15.0984 23.1276 15.6996C25.3094 16.2039 24.9797 13.4402 25.6779 12.1699C26.4536 10.7348 27.8694 9.639 29.547 9.639Z"
        fill="#FB6E7E"
      />
      <path
        d="M51.7041 57.9878H12.2956C12.189 57.9878 12.0823 57.9878 11.9756 57.9684C5.86654 57.8036 1.08594 52.8969 1.08594 46.7684V26.1042C1.08594 19.9757 5.86654 15.069 11.9756 14.9042C12.0823 14.8945 12.189 14.8848 12.2956 14.8848H51.7041C52.5962 14.8848 53.4496 14.9817 54.235 15.1854C59.3356 16.349 62.9138 20.8387 62.9138 26.1042V46.7684C62.9138 52.0339 59.3356 56.5236 54.2253 57.6872C53.4496 57.8811 52.5962 57.9878 51.7041 57.9878ZM12.2375 16.3005C12.2084 16.3005 12.1793 16.3005 12.1599 16.3102C12.1211 16.3199 12.092 16.3199 12.0629 16.3199C6.70048 16.446 2.5017 20.7417 2.5017 26.1042V46.7684C2.5017 52.1308 6.70048 56.4363 12.0629 56.5526C12.1017 56.5526 12.1308 56.5527 12.1599 56.5623C12.2084 56.572 12.2568 56.572 12.3053 56.5623H51.7138C52.4896 56.5623 53.2265 56.4751 53.9053 56.3005C58.395 55.2726 61.5175 51.3551 61.5175 46.7587V26.1042C61.5175 21.5078 58.395 17.5805 53.9247 16.5623C53.2265 16.3878 52.4896 16.3005 51.7138 16.3005H12.2956C12.2762 16.3005 12.2568 16.3005 12.2375 16.3005Z"
        fill="#980A08"
      />
      <path
        d="M45.1588 16.2425C44.7709 16.2425 44.4509 15.9225 44.4509 15.5346V14.274C44.4509 10.4922 41.9491 7.41827 38.8752 7.41827H28.1309C26.6085 7.41827 25.2121 8.02918 24.1843 9.15403C23.3891 10.0171 22.5067 11.5395 22.497 14.0219C22.5261 14.0995 22.5455 14.1868 22.5455 14.2837V15.1565C22.5455 15.5346 22.2449 15.8449 21.8764 15.8643C21.4982 15.8934 21.1782 15.6025 21.1394 15.2243C20.8194 11.588 22.0509 9.40615 23.1467 8.21342C24.4364 6.78797 26.2109 6.01221 28.1309 6.01221H38.8752C42.7249 6.01221 45.8667 9.71645 45.8667 14.274V15.5346C45.8667 15.9225 45.5467 16.2425 45.1588 16.2425Z"
        fill="#980A08"
      />
      <path
        d="M42.0747 15.8935C41.6868 15.8935 41.3668 15.5735 41.3668 15.1856C41.3668 12.5093 39.6117 10.3371 37.4493 10.3371H29.5462C27.3838 10.3371 25.6286 12.5093 25.6286 15.1856C25.6286 15.5735 25.3086 15.8935 24.9208 15.8935C24.5329 15.8935 24.2129 15.5735 24.2129 15.1856C24.2129 11.7335 26.5983 8.92139 29.5365 8.92139H37.4396C40.3777 8.92139 42.7632 11.7335 42.7632 15.1856C42.7826 15.5832 42.4626 15.8935 42.0747 15.8935Z"
        fill="#980A08"
      />
      <path
        d="M18.5989 57.9878H12.2959C12.1698 57.9878 12.0437 57.9878 11.9177 57.9587C11.5783 57.9005 11.3262 57.6096 11.3262 57.2605V15.612C11.3262 15.2629 11.5783 14.972 11.9177 14.9139C12.0437 14.8945 12.1698 14.8848 12.2959 14.8848H18.5989C18.9868 14.8848 19.3068 15.2048 19.3068 15.5926V57.2799C19.3068 57.6678 18.9868 57.9878 18.5989 57.9878ZM12.7419 56.572H17.9007V16.3005H12.7419V56.572Z"
        fill="#980A08"
      />
      <path
        d="M51.7035 57.9879H47.5048C47.1169 57.9879 46.7969 57.6679 46.7969 57.28V15.6024C46.7969 15.2145 47.1169 14.8945 47.5048 14.8945H51.7035C52.5957 14.8945 53.449 14.9915 54.2345 15.1951C54.5448 15.2727 54.7678 15.5539 54.7678 15.8836V57.0085C54.7678 57.3285 54.5448 57.6097 54.2345 57.697C53.449 57.8812 52.5957 57.9879 51.7035 57.9879ZM48.2029 56.5721H51.7035C52.2757 56.5721 52.8381 56.5236 53.3617 56.4267V16.446C52.8381 16.3491 52.2757 16.3006 51.7035 16.3006H48.2029V56.5721Z"
        fill="#980A08"
      />
      <path
        d="M34.6521 45.2121H31.5005C31.1127 45.2121 30.7927 44.8921 30.7927 44.5042V40.9939L27.9224 43.0109C27.6024 43.2339 27.166 43.1564 26.943 42.8364L25.1296 40.257C25.023 40.1018 24.9745 39.9176 25.0133 39.7333C25.0424 39.5491 25.149 39.3842 25.3042 39.2776L29.2605 36.4945L25.4593 33.5079C25.3139 33.3915 25.2169 33.2267 25.1975 33.0424C25.1781 32.8582 25.2266 32.6739 25.343 32.5188L27.2921 30.0364C27.5345 29.7261 27.9708 29.6776 28.2811 29.92L30.7927 31.9176V28.7079C30.7927 28.32 31.1127 28 31.5005 28H34.6521C35.0399 28 35.3599 28.32 35.3599 28.7079V32.2182L38.2302 30.2012C38.5502 29.9782 38.9866 30.0558 39.2096 30.3758L41.023 32.9358C41.246 33.2558 41.1684 33.6921 40.8484 33.9152L36.8921 36.6982L40.6933 39.6848C41.0036 39.9273 41.0521 40.3636 40.8096 40.6739L38.8605 43.1564C38.7442 43.3018 38.5793 43.3988 38.3951 43.4182C38.2108 43.4376 38.0266 43.3891 37.8714 43.2727L35.3405 41.2848V44.4945C35.3599 44.8921 35.0399 45.2121 34.6521 45.2121ZM32.2084 43.7964H33.9539V39.84C33.9539 39.5685 34.109 39.3261 34.3514 39.2097C34.5939 39.0933 34.8848 39.1224 35.0981 39.2873L38.2108 41.7309L39.2872 40.3636L35.2921 37.2315C35.1175 37.0958 35.0205 36.8824 35.0205 36.6594C35.0302 36.4364 35.1369 36.2327 35.3211 36.097L39.4714 33.1782L38.4727 31.7527L35.069 34.1479C34.8557 34.303 34.5745 34.3127 34.3418 34.1964C34.109 34.0703 33.9636 33.8376 33.9636 33.5661V29.4061H32.2181V33.3624C32.2181 33.6339 32.063 33.8764 31.8205 33.9927C31.5781 34.1091 31.2872 34.08 31.0739 33.9152L27.9611 31.4715L26.8848 32.8388L30.8799 35.9709C31.0545 36.1067 31.1514 36.32 31.1514 36.543C31.1418 36.7661 31.0351 36.9697 30.8508 37.1055L26.7005 40.0242L27.6993 41.4497L31.103 39.0545C31.3163 38.8994 31.5975 38.8897 31.8302 39.0061C32.063 39.1224 32.2084 39.3648 32.2084 39.6364V43.7964Z"
        fill="#980A08"
      />
      <path
        d="M6.21529 33.7167C6.03104 33.707 6.01165 31.4282 6.1668 28.616C6.33165 25.8136 6.60317 23.5445 6.78741 23.5542C6.97165 23.5639 6.99104 25.8427 6.83589 28.6548C6.68074 31.4573 6.39953 33.7264 6.21529 33.7167Z"
        fill="#A93C5A"
      />
      <defs>
        <radialGradient
          id="paint0_radial_3474_63686"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.5 27) rotate(-140.44) scale(29.8329 27.3146)"
        >
          <stop stop-color="#CDD4FF" />
          <stop offset="1" stop-color="#CDD4FF" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_3474_63686"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(56 23) rotate(123.69) scale(30.6472 44.4274)"
        >
          <stop stop-color="#C1E7DB" />
          <stop offset="1" stop-color="#C1E7DB" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_3474_63686"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 20) rotate(75.9638) scale(16.4924 2.62286)"
        >
          <stop stop-color="#FE94B2" />
          <stop offset="1" stop-color="#FE94B2" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_3474_63686"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(54 43.5) rotate(80.9097) scale(12.659 1.99398)"
        >
          <stop stop-color="#F288A8" />
          <stop offset="1" stop-color="#F288A8" stop-opacity="0" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_3474_63686"
          x1="31.5"
          y1="31.5"
          x2="33.314"
          y2="44.5385"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEE08C" />
          <stop offset="1" stop-color="#FF9768" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default GraphicBag
